import { useEffect, useState } from "react";
import useModal, { MODAL_XL } from "../../../../../../../../../modules/theme/Component/hooks/useModal";
import useDataBean from "../../../../../../../../../core/services/dataBean/useDataBean";
import { _AdquisitionContract, _single } from "../../../../../../../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../../../../../../../../modules/theme/Component/PrintJson";
import { Modal } from "../../../../../../../../../modules/theme/Component/Modal";
import "./MyResumenContractPayment.css"
import { VisorDocumentFactory } from "../../../../../../../../../modules/documents/VisorDocumentFactory";

interface Props {
    nameProp: string;
    props: any;
    documentSetter: Function;
}

export const MyResumenContractPayment = ({ nameProp, props, documentSetter }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_AdquisitionContract);

    const [document, setDocument] = useState<any>({});


    useEffect(() => {
        let filter = {};
        filter[nameProp] = props[nameProp];
        instance.getResumenPayment(_single.getCurrenYear(), filter, null).then(
            (resp: any) => {
                setLista(resp);
            }
        )
    }, [props])

    const data = lista?.DataBeanProperties || lista?.[0]?.DataBeanProperties;

    const verCDP = () => {
        documentSetter?.({ Mnemonic: data.CDPMnemonic, Consecutive: data.CDPConsecutive });
    }

    const verRP = () => {
        documentSetter?.({ Mnemonic: data.RPMnemonic, Consecutive: data.RPConsecutive });
    }

    const verOB = () => {
        documentSetter?.({ Mnemonic: data.OBMnemonic, Consecutive: data.OBConsecutive });
    }



    if (!data) return null;

    return (
        <div className="contract-resumen">
            <div className="mb-3">
                <div className="contract-title">Información General</div>

                <p className="mb-2">{data.Description}</p>

            </div>

            <div className="mt-4 d-flex gap-2">

                <button className="btn btn-outline-primary btn-sm" onClick={verCDP}>
                    Ver CDP
                </button>

                <button className="btn btn-outline-primary btn-sm" onClick={verRP}>
                    Ver RP
                </button>

                <button className="btn btn-outline-primary btn-sm" onClick={verOB}>
                    Ver OB
                </button>

            </div>
        </div>
    );
}